export default "__VITE_ASSET__BsUGxFSY__"